(() => {
  'use strict';
  // German storefront URLs must never switch to the international domain.
  // Apply this to every visitor, independently of location or user agent.
  const germanDomain = /^(www\.)?mynordhaus\.de$/.test(location.hostname);
  if (germanDomain) {
    const germanPath = location.pathname.replace(/^\/en(?:-(?:eu|no|je|ge|tr|ru))?(?=\/|$)/, '') || '/';
    if (germanPath !== location.pathname) {
      const url = new URL(location.href);
      url.pathname = germanPath;
      location.replace(url.href);
    }
    return;
  }
  const node = document.getElementById('nh-market-context');
  if (!node) return;
  let context;
  try { context = JSON.parse(node.textContent); } catch { return; }
  const internationalDomain = /^(www\.)?mynordhaus\.com$/.test(location.hostname);
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch {} }
  };
  const remember = () => storage.set('nh-country-manual', '1');
  const localeFor = country => country === 'DE' ? 'de' : 'en';
  const preservePage = form => {
    let input = form.querySelector('[name="return_to"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.append(input); }
    input.value = location.pathname + location.search + location.hash;
  };
  document.querySelectorAll('form[action*="localization"]').forEach(form => {
    form.addEventListener('submit', event => {
      if (form.id === 'nh-country-auto-form') return;
      const submitter = event.submitter;
      const country = submitter?.name === 'country_code' ? submitter.value : form.querySelector('select[name="country_code"]')?.value;
      if (country) {
        let locale = form.querySelector('[name="locale_code"]');
        if (!locale) { locale = document.createElement('input'); locale.type = 'hidden'; locale.name = 'locale_code'; form.append(locale); }
        locale.value = localeFor(country);
      }
      remember();
    });
  });
  // Existing English content used /en/ links before international market paths existed.
  // Preserve the current market when following these internal links.
  const root = context.root.replace(/\/$/, '');
  if (context.locale === 'en' && root !== '/en') {
    document.querySelectorAll('a[href]').forEach(a => {
      try {
        const url = new URL(a.getAttribute('href'), location.origin);
        if (url.origin === location.origin && /^\/en(?:\/|$)/.test(url.pathname)) {
          url.pathname = url.pathname.replace(/^\/en(?=\/|$)/, root);
          a.href = url.pathname + url.search + url.hash;
        }
      } catch {}
    });
  }
  if (storage.get('nh-country-manual') || new URLSearchParams(location.search).has('country')) return;
  const auto = document.getElementById('nh-country-auto-form');
  if (!auto) return;
  const apply = (country, locale) => {
    const key = country + ':' + locale;
    if (storage.get('nh-country-attempt') === key) return;
    storage.set('nh-country-attempt', key);
    auto.querySelector('[name="country_code"]').value = country;
    auto.querySelector('[name="locale_code"]').value = locale;
    preservePage(auto); auto.submit();
  };
  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=true', {credentials:'same-origin'})
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const detected = data?.detected_values?.country?.handle;
      if (!detected) return;
      if (detected === 'DE') {
        if (internationalDomain) apply('DE', 'de');
        return;
      }
      const target = context.countries.find(c => c.code === detected);
      if (!target) return;
      if (context.country === detected && context.locale === 'en') return;
      apply(detected, 'en');
    }).catch(() => {});
})();
